const items = [
  "On-device",
  "No uploads",
  "Batch up to 50",
  "Pure white or black",
  "No sign-ins",
  "No tracking",
  "Private by design",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-line bg-ink py-5 sm:py-6" data-testid="home-marquee">
      <div className="flex w-max animate-marquee items-center gap-10 sm:gap-16 will-change-transform">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-10 sm:gap-16">
            <span className="font-display text-xl sm:text-2xl font-semibold tracking-tight text-paper">
              {t}
            </span>
            <span className="h-2 w-2 rotate-45 bg-brand-bright" />
          </span>
        ))}
      </div>
    </div>
  );
};
